export const TiptapEditorTestIds = {
  inputChat: 'input_chat',
  buttonCanceledit: 'button_canceledit',
  buttonEditmessage: 'button_editmessage',
  buttonUploadfile: 'button_uploadfile',
  inputUploadfile: 'input_uploadfile',
  buttonSendmessage: 'button_sendmessage',
  buttonDelete: 'button_delete'
} as const;

export const ResponseMessageTestIds = {
  fieldMessage: 'field_message',
  fieldReplyContent: 'field_reply_content',
  linkDownloadfile: 'link_downloadfile'
} as const;
